<template>
  <div id="gwi-myPay" class="app my-app">
    <section class="thick">
      <hospital-select
        id="myPay-select-hospital"
        @selected="selectHospital"
      ></hospital-select>
      <voucher-select
        id="myPay-select-voucher"
        :list="voucherList"
        @selected="selectVoucher"
      ></voucher-select>
      <div class="query-more">
        <span>此处展示近三个月的历史记录</span>
        <button class="btn-ok" @click="loadMore()">更多</button>
      </div>
    </section>
    <div class="query-history" v-show="isChoose">
      <div class="time">请选择查询时间段</div>
      <div class="history-more">
        <div class="option" id="StartDate" @click="setStartDate">
          {{ startDate }}
        </div>
        <span></span>
        <div class="option" id="EndDate" @click="setEndDate">{{ endDate }}</div>
        <button class="btn-ok" @click="chooseNewDate()">确定</button>
      </div>
    </div>
    <scroll @refresh="refresh" id="my-pay-scroll" class="from-query-more">
      <section
        :id="'myPay-payItem-' + index"
        class="thick my-pay"
        v-for="(pay, index) in payList"
        :key="index"
      >
        <div class="panel">{{ pay.visitName }}</div>
        <div
          :id="'myPay-payItem-goDetail' + index"
          class="row arr-row table-row"
          @click="goDetail(pay)"
        >
          <div class="col">
            <p class="f-minor">
              缴费时间&nbsp;&nbsp;&nbsp;{{ pay.orderTime | formatpayDate }}
            </p>
          </div>
          <div class="col mycol">
            <p class="f-strongest">{{ pay.fee | formatFee }}</p>
          </div>
        </div>
      </section>
      <no-record
        :condition="payList"
        :tips="'抱歉，没有缴费记录！'"
      ></no-record>
    </scroll>
  </div>
</template>
<script>
import NoRecord from 'NoRecord'
import queryFun from 'queryFunList.service'
import queryVoucher from 'voucher.service'
import HospitalSelect from 'HospitalSelect'
import VoucherSelect from 'VoucherSelect'
import voucherService from 'voucher.service'

export default {
  components: {
    NoRecord,
    HospitalSelect,
    VoucherSelect
  },
  data () {
    return {
      isChoose: false,
      payList: [],
      noRecord: false,
      voucher: {},
      voucherList: [],
      utils: this.$utils,
      startDate: '',
      endDate: ''
    };
  },
  created () {
    //判断是否存在tokenId,且当前界面code失效
    var query = this.$router.currentRoute.query
    var code = query.code
    if (code) {
      var getTokenParams = { code: code }
      voucherService.getToken(getTokenParams).then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          //查询该用户未使用过该公众号
          this.loadVouchers()
          return
        }
        //缓存最新code给后台
        localStorage.setItem('deviceId', code);
        sessionStorage.setItem('deviceId', code);
        //返回新token保存本地使用
        localStorage.tokenId = res.data.tokenId;
        localStorage.setItem('tokenId', res.data.tokenId);
        sessionStorage.setItem('tokenId', res.data.tokenId);
        window.http.headers.common['tokenId'] = localStorage.tokenId || ''
        window.http.headers.common['deviceId'] = localStorage.deviceId || ''
        this.loadVouchers()
      })
    } else {
      this.loadVouchers()
    }
  },
  methods: {
    refresh () {
      if (!this.voucher.cardType || !this.voucher.cardNo) {
        this.$utils.alert('请先绑定诊疗卡');
        return;
      }

      var params = {
        cardType: this.voucher.cardType,
        cardNo: this.voucher.cardNo
      };

      //处理初始进入微信的未选医院情况
      if (typeof (http.headers.common['hospitalId']) === "undefined") {
        this.$utils.alert("请选择医院");
        return;
      }

      this.loadMyPayList(params);
    },
    loadVouchers () {
      // 获取用户就诊凭证
      queryVoucher.getVoucherList().then((res) => {
        if (res.resultCode !== this.constant.RESULT_SUCCESS) {
          this.$utils.alert(res.resultMsg);
          return;
        }

        const data = res.data;
        if (data.length === 0) {
          this.$utils.alert('请先绑定诊疗卡');
          return;
        }
        this.voucherList = data;
        // 首次进入，默认第一张诊疗卡信息
        this.voucher = JSON.parse(JSON.stringify(this.voucherList[0]));

        // 保存默认卡信息
        this.$store.commit('updateParam', {
          namespace: 'mypay',
          voucher: this.voucher,
        });
        this.refresh();
      });
    },
    selectHospital () {
      this.payList = this.constant.ARRAY_CLEAN;
      this.refresh();
    },
    selectVoucher (v) {
      this.payList = this.constant.ARRAY_CLEAN;
      this.voucher = v;

      //保存默认卡信息
      this.$store.commit('updateParam', {
        namespace: 'mypay',
        voucher: v
      });
      //加载默认卡的待缴费列表
      this.refresh();
    },
    loadMyPayList (params) {
      queryFun.getMyPayList(params).then((res) => {
        if (typeof res === "string") {
          //this.$utils.alert(res);
          this.payList = []
          return;
        }
        this.payList = res || [];
      });
    },
    goDetail (pay) {
      this.$store.commit('updateParam', {
        namespace: 'mypay',
        pay: pay,
        queryParam: {
          holderName: pay.holderName,
          cardType: this.voucher.cardType,
          cardNo: this.voucher.cardNo,
          orderTime: pay.orderTime,
          orderId: pay.orderId,
          visitName: pay.visitName,
          doctName: pay.doctName,
          fee: pay.fee
        }
      });
      this.$router.push('mypayDetail');
    },
    //默认初始化日历控件
    formatDatePicker () {
      var dateOb = new Date()
      var year = dateOb.getFullYear()
      var month = dateOb.getMonth()
      var day = dateOb.getDate()
      var lastDay = new Date(year, month, day);
      this.startDate = lastDay.format('yyyy-MM-dd')
      this.endDate = lastDay.format('yyyy-MM-dd')
    },
    //判断日期是否合法
    checkDate (sDate, eDate) {
      var formate = new RegExp(/-/g);
      sDate = sDate.replace(formate, "");
      eDate = eDate.replace(formate, "");
      //判断日期大小及合法性
      if ((sDate > eDate) || (sDate === '') || (eDate === '')) {
        this.$utils.alert('日期输入格式不正确，请重新输入');
        return false
      }
      return true
    },
    /* eslint-disable */
    loadMore () {
      this.isChoose = !this.isChoose
      //往下瞬移控件
      if (this.isChoose) {
        $("#my-pay-scroll").addClass("include-date-scroll")
        $("#my-pay-scroll").removeClass("from-query-more")
        $("#my-pay-scroll").removeClass("scroll")
      } else {
        $("#my-pay-scroll").removeClass("include-date-scroll")
        $("#my-pay-scroll").addClass("from-query-more")
        $("#my-pay-scroll").addClass("scroll")
      }
      //初始化日期控件
      this.formatDatePicker();
    },
    setStartDate () {
      const today = new Date()
      var maxDate = today.format('yyyy-MM-dd')
      today.setMonth(today.getMonth() - 12)
      var minDate = today.format('yyyy-MM-dd')
      this.$picker.show({
        type: 'datePicker',
        date: this.startDate,  //初始化时间
        endTime: maxDate,  //截至时间
        startTime: minDate,  //开始时间
        onOk: (e) => {
          //格式化成统一格式
          var newDate = new Date(e.replace(/-/g, "/"))
          this.startDate = newDate.format('yyyy-MM-dd')
        }
      });
    },
    setEndDate () {
      const today = new Date()
      var maxDate = today.format('yyyy-MM-dd')
      today.setMonth(today.getMonth() - 12)
      var minDate = today.format('yyyy-MM-dd')
      this.$picker.show({
        type: 'datePicker',
        date: this.endDate,  //初始化时间
        endTime: maxDate,  //截至时间
        startTime: minDate,  //开始时间
        onOk: (e) => {
          //格式化成统一格式
          var newDate = new Date(e.replace(/-/g, "/"))
          this.endDate = newDate.format('yyyy-MM-dd')
        },
      })
    },
    chooseNewDate () {
      var params = {
        cardType: this.voucher.cardType,
        cardNo: this.voucher.cardNo
      };
      if (this.checkDate(this.startDate, this.endDate)) {
        params.startDate = this.startDate
        params.endDate = this.endDate
        this.loadMyPayList(params)
      }
    }
  },
  watch: {
    payList (val) {
      this.noRecord = val.length === 0;
    }
  }
}
</script>
<style lang="scss">
.my-app {
  background-color: #eff2f5;
  .my-pay {
    .panel {
      height: 1rem;
      line-height: 1rem;
    }
    .table-row {
      height: 1.5rem;
      padding: 0.3rem 0.3rem;
      border-bottom: none;
    }
    .mycol {
      padding-right: 23px;
      text-align: right;
      .f-strongest {
        color: #ff0101;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Mypay.vue?5d14677f